export const LANGUAGES = {
  en:  { name: 'English',     dir: 'ltr' },
  ar:  { name: 'العربية',    dir: 'rtl' },
  ka:  { name: 'ქართული',   dir: 'ltr' },
  ru:  { name: 'Русский',    dir: 'ltr' },
  ja:  { name: '日本語',     dir: 'ltr' },
  tr:  { name: 'Türkçe',    dir: 'ltr' },
  de:  { name: 'Deutsch',    dir: 'ltr' },
  fr:  { name: 'Français',   dir: 'ltr' },
  es:  { name: 'Español',    dir: 'ltr' },
  it:  { name: 'Italiano',   dir: 'ltr' },
  pt:  { name: 'Português',  dir: 'ltr' },
  nl:  { name: 'Nederlands', dir: 'ltr' },
  pl:  { name: 'Polski',     dir: 'ltr' },
  az:  { name: 'Azərbaycan', dir: 'ltr' },
  hy:  { name: 'Հայերեն',   dir: 'ltr' },
  zh:  { name: '中文',       dir: 'ltr' },
  ko:  { name: '한국어',     dir: 'ltr' },
  mn:  { name: 'Монгол',    dir: 'ltr' },
  th:  { name: 'ภาษาไทย',  dir: 'ltr' },
  vi:  { name: 'Tiếng Việt', dir: 'ltr' },
  ms:  { name: 'Melayu',    dir: 'ltr' },
  id:  { name: 'Indonesia',  dir: 'ltr' },
  fil: { name: 'Filipino',   dir: 'ltr' },
  ur:  { name: 'اردو',      dir: 'rtl' },
  bn:  { name: 'বাংলা',    dir: 'ltr' },
  hi:  { name: 'हिंदी',    dir: 'ltr' },
  sw:  { name: 'Kiswahili',  dir: 'ltr' },
  am:  { name: 'አማርኛ',    dir: 'ltr' },
  el:  { name: 'Ελληνικά',  dir: 'ltr' },
};

// Maps lowercase country name → language code.
// Used to auto-add a language when a customer's country is saved.
export const COUNTRY_LANG = {
  // English
  'uk': 'en', 'united kingdom': 'en', 'england': 'en', 'scotland': 'en',
  'usa': 'en', 'united states': 'en', 'us': 'en', 'america': 'en',
  'australia': 'en', 'new zealand': 'en', 'canada': 'en', 'ireland': 'en',
  'nigeria': 'en', 'ghana': 'en', 'kenya': 'en', 'uganda': 'en',
  'zimbabwe': 'en', 'south africa': 'en', 'zambia': 'en',
  'singapore': 'en', 'fiji': 'en', 'papua new guinea': 'en',
  // Arabic
  'uae': 'ar', 'united arab emirates': 'ar',
  'saudi arabia': 'ar', 'ksa': 'ar',
  'kuwait': 'ar', 'qatar': 'ar', 'bahrain': 'ar',
  'oman': 'ar', 'iraq': 'ar', 'jordan': 'ar',
  'lebanon': 'ar', 'syria': 'ar', 'yemen': 'ar', 'libya': 'ar',
  'egypt': 'ar', 'morocco': 'ar', 'algeria': 'ar', 'tunisia': 'ar',
  'sudan': 'ar',
  // Georgian
  'georgia': 'ka',
  // Russian / CIS
  'russia': 'ru', 'russian federation': 'ru',
  'ukraine': 'ru', 'belarus': 'ru', 'moldova': 'ru',
  'kazakhstan': 'ru', 'kyrgyzstan': 'ru',
  'tajikistan': 'ru', 'turkmenistan': 'ru',
  // Japanese
  'japan': 'ja',
  // Turkish
  'turkey': 'tr', 'türkiye': 'tr', 'north cyprus': 'tr', 'northern cyprus': 'tr', 'trnc': 'tr',
  // Greek
  'cyprus': 'el', 'south cyprus': 'el', 'greece': 'el',
  // German
  'germany': 'de', 'austria': 'de',
  // French
  'france': 'fr', 'belgium': 'fr',
  // Spanish
  'spain': 'es', 'mexico': 'es', 'colombia': 'es',
  'argentina': 'es', 'chile': 'es', 'peru': 'es',
  // Italian
  'italy': 'it',
  // Portuguese
  'portugal': 'pt', 'brazil': 'pt', 'mozambique': 'pt', 'angola': 'pt',
  // Dutch
  'netherlands': 'nl', 'holland': 'nl',
  // Polish
  'poland': 'pl',
  // Azerbaijani
  'azerbaijan': 'az',
  // Armenian
  'armenia': 'hy',
  // Chinese
  'china': 'zh', 'taiwan': 'zh',
  // Korean
  'south korea': 'ko', 'korea': 'ko',
  // Mongolian
  'mongolia': 'mn',
  // Thai
  'thailand': 'th',
  // Vietnamese
  'vietnam': 'vi',
  // Malay
  'malaysia': 'ms',
  // Indonesian
  'indonesia': 'id',
  // Filipino
  'philippines': 'fil',
  // Urdu
  'pakistan': 'ur',
  // Bengali
  'bangladesh': 'bn',
  // Hindi
  'india': 'hi',
  // Swahili
  'tanzania': 'sw',
  // Amharic
  'ethiopia': 'am',
};

export const translations = {
  en: {
    // Navigation
    dashboard: 'Dashboard',
    inventory: 'Inventory',
    vehicles: 'Vehicles',
    engines: 'Engines',
    parts: 'Parts',
    containers: 'Containers',
    customers: 'Customers',
    requests: 'Requests',
    myStock: 'My Stock',
    selectionOrders: 'Selection Orders',
    priceQuotes: 'Price Quotes',
    invoices: 'Invoices',
    payments: 'Payments',
    employees: 'Staff',
    settings: 'Settings',
    scan: 'Scan QR',
    
    // Actions
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    import: 'Import',
    print: 'Print',
    download: 'Download',
    signIn: 'Sign In',
    signOut: 'Sign Out',
    
    // Labels
    sku: 'SKU',
    chassis: 'Chassis',
    make: 'Make',
    model: 'Model',
    year: 'Year',
    color: 'Color',
    mileage: 'Mileage',
    displacement: 'Displacement',
    transmission: 'Transmission',
    port: 'Port',
    status: 'Status',
    price: 'Price',
    cost: 'Cost',
    fobPrice: 'FOB Price',
    condition: 'Condition',
    quantity: 'Quantity',
    category: 'Category',
    fitment: 'Fitment',
    cutType: 'Cut Type',
    daysInStock: 'Days in Stock',
    
    // Statuses
    available: 'Available',
    assigned: 'Assigned',
    transit: 'In Transit',
    sold: 'Sold',
    pending: 'Pending',
    processing: 'Processing',
    loading: 'Loading',
    arrived: 'Arrived',
    
    // Dashboard
    totalUnits: 'Total Units',
    totalVehicles: 'Total Vehicles',
    totalEngines: 'Total Engines',
    totalParts: 'Total Parts',
    inTransit: 'In Transit',
    pendingRequests: 'Pending Requests',
    totalCustomers: 'Total Customers',
    inventoryValue: 'Inventory Value',
    salesOverview: 'Sales Overview',
    recentActivity: 'Recent Activity',
    
    // Forms
    username: 'Username',
    email: 'Email',
    password: 'Password',
    name: 'Name',
    company: 'Company',
    country: 'Country',
    phone: 'Phone',
    
    // Messages
    noData: 'No data available',
    loading: 'Loading...',
    error: 'An error occurred',
    success: 'Success',
    confirmDelete: 'Are you sure you want to delete this item?',
    invalidCredentials: 'Invalid credentials',
    
    // Misc
    staffPortal: 'Staff Portal',
    customerPortal: 'Customer Portal',
    demoAccounts: 'Demo Accounts',
    whatsAppInquiry: 'WhatsApp Inquiry',
    printQR: 'Print QR',
    viewDetails: 'View Details',
    costSummary: 'Cost Summary',
    totalFOB: 'Total FOB'
  },
  
  ar: {
    // Navigation
    dashboard: 'لوحة القيادة',
    inventory: 'المخزون',
    vehicles: 'المركبات',
    engines: 'المحركات',
    parts: 'قطع الغيار',
    containers: 'الحاويات',
    customers: 'العملاء',
    requests: 'الطلبات',
    myStock: 'مخزوني',
    employees: 'الموظفين',
    settings: 'الإعدادات',
    scan: 'مسح QR',
    
    // Actions
    add: 'إضافة',
    edit: 'تعديل',
    delete: 'حذف',
    save: 'حفظ',
    cancel: 'إلغاء',
    search: 'بحث',
    filter: 'تصفية',
    export: 'تصدير',
    import: 'استيراد',
    print: 'طباعة',
    download: 'تحميل',
    signIn: 'تسجيل الدخول',
    signOut: 'تسجيل الخروج',
    
    // Labels
    sku: 'رقم المنتج',
    chassis: 'رقم الهيكل',
    make: 'الشركة المصنعة',
    model: 'الموديل',
    year: 'السنة',
    color: 'اللون',
    mileage: 'الكيلومترات',
    displacement: 'سعة المحرك',
    transmission: 'ناقل الحركة',
    port: 'الميناء',
    status: 'الحالة',
    price: 'السعر',
    cost: 'التكلفة',
    fobPrice: 'سعر FOB',
    condition: 'الحالة',
    quantity: 'الكمية',
    category: 'الفئة',
    fitment: 'التوافق',
    cutType: 'نوع القطع',
    daysInStock: 'أيام في المخزون',
    
    // Statuses
    available: 'متاح',
    assigned: 'مخصص',
    transit: 'في الطريق',
    sold: 'مباع',
    pending: 'قيد الانتظار',
    processing: 'قيد المعالجة',
    loading: 'جاري التحميل',
    arrived: 'وصل',
    
    // Dashboard
    totalUnits: 'إجمالي الوحدات',
    totalVehicles: 'إجمالي المركبات',
    totalEngines: 'إجمالي المحركات',
    totalParts: 'إجمالي القطع',
    inTransit: 'في الطريق',
    pendingRequests: 'الطلبات المعلقة',
    totalCustomers: 'إجمالي العملاء',
    inventoryValue: 'قيمة المخزون',
    salesOverview: 'نظرة عامة على المبيعات',
    recentActivity: 'النشاط الأخير',
    
    // Forms
    username: 'اسم المستخدم',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    name: 'الاسم',
    company: 'الشركة',
    country: 'البلد',
    phone: 'الهاتف',
    
    // Messages
    noData: 'لا توجد بيانات',
    loading: 'جاري التحميل...',
    error: 'حدث خطأ',
    success: 'تم بنجاح',
    confirmDelete: 'هل أنت متأكد من حذف هذا العنصر؟',
    invalidCredentials: 'بيانات الدخول غير صحيحة',
    
    // Misc
    staffPortal: 'بوابة الموظفين',
    customerPortal: 'بوابة العملاء',
    demoAccounts: 'حسابات تجريبية',
    whatsAppInquiry: 'استفسار واتساب',
    printQR: 'طباعة QR',
    viewDetails: 'عرض التفاصيل',
    costSummary: 'ملخص التكلفة',
    totalFOB: 'إجمالي FOB'
  },
  
  ka: {
    dashboard: 'მთავარი',
    inventory: 'ინვენტარი',
    vehicles: 'მანქანები',
    engines: 'ძრავები',
    parts: 'ნაწილები',
    containers: 'კონტეინერები',
    customers: 'მომხმარებლები',
    requests: 'მოთხოვნები',
    myStock: 'ჩემი მარაგი',
    employees: 'თანამშრომლები',
    settings: 'პარამეტრები',
    scan: 'QR სკანირება',
    add: 'დამატება',
    edit: 'რედაქტირება',
    delete: 'წაშლა',
    save: 'შენახვა',
    cancel: 'გაუქმება',
    search: 'ძებნა',
    signIn: 'შესვლა',
    signOut: 'გასვლა',
    available: 'ხელმისაწვდომი',
    assigned: 'მინიჭებული',
    transit: 'ტრანზიტში',
    pending: 'მოლოდინში',
    totalUnits: 'სულ ერთეული',
    noData: 'მონაცემები არ არის'
  },
  
  ru: {
    dashboard: 'Панель',
    inventory: 'Инвентарь',
    vehicles: 'Автомобили',
    engines: 'Двигатели',
    parts: 'Запчасти',
    containers: 'Контейнеры',
    customers: 'Клиенты',
    requests: 'Запросы',
    myStock: 'Мой склад',
    employees: 'Сотрудники',
    settings: 'Настройки',
    scan: 'Сканировать QR',
    add: 'Добавить',
    edit: 'Редактировать',
    delete: 'Удалить',
    save: 'Сохранить',
    cancel: 'Отмена',
    search: 'Поиск',
    signIn: 'Войти',
    signOut: 'Выйти',
    available: 'Доступен',
    assigned: 'Назначен',
    transit: 'В пути',
    pending: 'Ожидание',
    totalUnits: 'Всего единиц',
    noData: 'Нет данных'
  },
  
  ja: {
    dashboard: 'ダッシュボード',
    inventory: '在庫',
    vehicles: '車両',
    engines: 'エンジン',
    parts: 'パーツ',
    containers: 'コンテナ',
    customers: '顧客',
    requests: 'リクエスト',
    myStock: 'マイストック',
    employees: 'スタッフ',
    settings: '設定',
    scan: 'QRスキャン',
    add: '追加',
    edit: '編集',
    delete: '削除',
    save: '保存',
    cancel: 'キャンセル',
    search: '検索',
    signIn: 'ログイン',
    signOut: 'ログアウト',
    available: '利用可能',
    assigned: '割当済',
    transit: '輸送中',
    pending: '保留中',
    totalUnits: '総ユニット',
    noData: 'データなし'
  }
};

// Get translation
export const t = (key, lang = 'en') => {
  return translations[lang]?.[key] || translations.en[key] || key;
};
